import $ from './jquery';
import './bootstrap';

// LOKALNE
import './components/jquery.autocomplete';
import './components/jquery.sticky';
import './components/parallaxie';
import './components/leaflet-map-interactions';
import './components/restaurant-lead-form';
import './components/market-radar';
import './components/company-sidebar';

import AOS from 'aos';
import anime from 'animejs';
import confetti from 'canvas-confetti';
import Cookies from 'js-cookie/src/js.cookie';
import Dropzone from 'dropzone';
import QRCode from 'easyqrcodejs/dist/easy.qrcode.min';
import Favico from 'favico.js';
import flatpickr from 'flatpickr';
import { Polish } from 'flatpickr/dist/l10n/pl';
import { Slovenian } from 'flatpickr/dist/l10n/sl';
import Lang from 'lang.js';
import mergeImages from 'merge-images';
import SimpleLightbox from 'simplelightbox/dist/simple-lightbox.esm.js';
import Sortable from 'sortablejs';
import Swiper from 'swiper/swiper-bundle';
import 'starrr/dist/starrr.js';

window.Cookies = Cookies;
window.Swiper = Swiper;

window.flatpickr = flatpickr;
flatpickr.l10ns.pl = Polish;
flatpickr.l10ns.sl = Slovenian;

window.AOS = AOS;
AOS.init();

window.Sortable = Sortable;
window.anime = anime;
window.confetti = confetti;
window.Favico = Favico;
window.mergeImages = mergeImages;
window.SimpleLightbox = SimpleLightbox;

window.Dropzone = Dropzone;
Dropzone.autoDiscover = false;

window.lang = new Lang({
    messages: window.__javascriptTranslations,
    fallback: 'en',
});

import './core';
import './pwa';

window.QRCode = QRCode;
